import PanelSkeleton from '@shared/components/PanelSkeleton';
import { useActivity } from '../hooks/useActivity';
import ActivityTable from './ActivityTable';

interface Props {
  module: string;
}

export default function RecentActivity({ module }: Props) {
  const { data, isLoading } = useActivity({ module, page: 0, size: 5 });

  if (isLoading) return <PanelSkeleton />;

  return <ActivityTable entries={data?.items ?? []} loading={isLoading} />;
}
